// DE
export const calendarsChatbotHc = {
  monthlyCalendar: {
    pricesTitle: "Dynamische Preise",
    prices: "Preise",
    noPropertiesAvailable: "Keine Unterkünfte verfügbar",
    noPropertiesFound: "Keine Unterkünfte gefunden",
    minStayShort: "min. {n} N",
    available: "Verfügbar",
    closed: "Geschlossen",
    loading: "Wird geladen…",
    showMoreMonths: "Weitere Monate anzeigen",
    from: "Von",
    to: "Bis",
    nightsLabelOne: "{n} Nacht",
    nightsLabelMany: "{n} Nächte",
    whatToDo: "Was möchten Sie tun?",
    close: "Schließen",
    open: "Öffnen",
    price: "Preis",
    minStay: "Mindestaufenthalt",
    closeReasonPlaceholder: "Grund für die Schließung (optional)",
    openHint: "Die ausgewählten Daten werden wieder geöffnet (die Sperre wird entfernt).",
    nightsWord: "Nächte",
    clearSelection: "Auswahl aufheben",
    past: "Vergangen",
    guestOne: "Gast",
    guestMany: "Gäste",
    perNight: "/ Nacht",
    noName: "Ohne Namen",
    channelDirect: "Direkt",
    ownerBlockComment: "Sperre durch den Gastgeber",
    prepTime: "Vorbereitungszeit",
    sameDayCutoff: "Annahmeschluss am selben Tag",
    linkedClosed: "Ganze Wohnung",
    linkedClosedInfo: "Geschlossen durch die Regel für die ganze Wohnung ({motivo}). Die Daten öffnen sich von selbst wieder, wenn diese Buchung storniert wird oder sich ihre Daten ändern.",
    alsoLinked: "ebenfalls geschlossen durch die Regel für die ganze Wohnung ({motivo})",
    applyClose: "Daten schließen",
    applyOpen: "Daten öffnen",
    applyPrice: "Preis speichern",
    applyMinStay: "Mindestaufenthalt speichern",
    apply: "Anwenden",
    processing: "Wird verarbeitet…",
    closingDates: "Daten werden geschlossen…",
    openingDates: "Daten werden geöffnet…",
    priceModeLabel: "Preisart",
    priceModeFixed: "Fest",
    priceModePercent: "%",
    priceModeAmount: "Betrag",
    percentPlaceholder: "z. B. 20",
    amountPlaceholder: "z. B. 10",
    percentHint: "Jede Nacht wird auf ihren eigenen Preis neu berechnet. Mit − wird es weniger.",
    amountHint: "Wird auf den bisherigen Preis jeder Nacht addiert. Mit − wird es weniger.",
    invalidPrice: "Geben Sie einen gültigen Preis ein.",
    changingPrice: "Preis pro Nacht wird geändert…",
    priceUpdated: "Preis erfolgreich aktualisiert.",
    priceUpdateError: "Der Preis konnte nicht aktualisiert werden.",
    minStayMin: "Der Mindestaufenthalt muss mindestens 1 Nacht betragen.",
    changingMinStay: "Mindestaufenthalt wird geändert…",
    minStayUpdated: "Mindestaufenthalt erfolgreich aktualisiert.",
    minStayUpdateError: "Der Mindestaufenthalt konnte nicht aktualisiert werden.",
    unknownError: "Unbekannter Fehler",
  },
  calendar: {
    channelDirect: "Direkt",
    searchMin2: "Geben Sie mindestens 2 Zeichen zur Suche ein",
    searchNoResults: "Für diese Suche wurden keine Buchungen gefunden",
    searchError: "Fehler bei der Suche nach Buchungen",
    processing: "Wird verarbeitet…",
    ownerBlockComment: "Sperre durch den Gastgeber",
    cutoffTip: "Annahmeschluss für den Verkauf am selben Tag um {time}",
    nightsLabelOne: "{n} Nacht",
    nightsLabelMany: "{n} Nächte",
    turnoverBefore: "Vorbereitungszeit: {nights} vor jedem Check-in sperren",
    turnoverAfter: "Vorbereitungszeit: {nights} ab jedem Check-out sperren",
    turnoverBoth: "Vorbereitungszeit: {nights} vor dem Check-in und ab dem Check-out sperren",
    selectAtLeastOneProperty: "Wählen Sie mindestens eine Unterkunft aus.",
    selectAtLeastOneDate: "Wählen Sie mindestens ein Gültigkeitsdatum, um die Änderungen anzuwenden.",
    preparingOps: "{total} Vorgänge werden vorbereitet...",
    applyingOps: "{index} von {total} wird angewendet: {name}",
    unknownError: "Unbekannter Fehler",
    couldNotSaveChanges: "Die Änderungen konnten nicht gespeichert werden.",
    bulkApplyError: "Die Sammeländerungen konnten nicht angewendet werden. {message}",
    opsApplied: "{success} von {total} Vorgängen wurden angewendet.",
    opsSkipped: "{skipped} Daten mit bestätigten Buchungen wurden übersprungen.",
    opsFailed: "{failed} Vorgänge sind fehlgeschlagen.",
    bulkApplied: "Sammelbearbeitung auf {count} Unterkünfte angewendet.",
    couldNotOpenDate: "Das Datum konnte nicht geöffnet werden",
    datesOpened: "Daten geöffnet",
    closeUpdated: "Sperre aktualisiert",
    todayLabel: "Heute",
    closed: "Geschlossen",
    linkedClosed: "Ganze Wohnung",
    linkedClosedInfo: "Geschlossen durch die Regel für die ganze Wohnung ({motivo}). Die Daten öffnen sich von selbst wieder, wenn diese Buchung storniert wird oder sich ihre Daten ändern.",
    alsoLinked: "ebenfalls geschlossen durch die Regel für die ganze Wohnung ({motivo})",
    closingDates: "Daten werden geschlossen…",
    couldNotCloseDates: "Die Daten konnten nicht geschlossen werden",
    clearFiltersTitle: "Filter zurücksetzen",
    noPropertiesAvailable: "Keine Unterkünfte verfügbar",
    noPropertiesFound: "Keine Unterkünfte gefunden",
    dynamicPricesTitle: "Dynamische Preise",
    prices: "Preise",
    viewWide: "Breite Ansicht",
    viewCompact: "Kompakte Ansicht",
    viewNormal: "Normale Ansicht",
    viewFull: "Vollansicht",
    searchBookingTitle: "Buchung suchen",
    searchBookingPlaceholder: "Buchung suchen…",
    search: "Suchen",
    resultsSelectOne: "{count} Ergebnisse: eines auswählen:",
    bulkEdit: "Sammelbearbeitung",
    goToTodayTitle: "Zu heute springen",
    showHeader: "Kopfzeile anzeigen",
    configArrivalDeparture: "An- und Abreiseregeln einrichten",
    notAvailable: "Nicht verfügbar",
    extension: "Verlängerung",
    lateCheckoutUntil: "Späte Abreise bis {time}",
    aiRequests: "KI-Rezeption",
    guestComments: "Anmerkungen des Gastes",
    internalNotes: "Interne Notizen",
    extrasTitle: "Gebuchte Extras",
    extrasPending: "Wartet auf Bestätigung",
    reqArrivalTitle: "Ankunftszeit",
    reqAt: "um {time}",
    reqUntil: "bis {time}",
    reqNights: "Zusätzliche Nächte: {n}",
    reqPending: "Ausstehend",
    reqConfirmed: "Bestätigt",
    reqPaid: "Bezahlt",
    reqOffered: "Angeboten",
    reqPrioritised: "Priorisiert",
    pendingAmount: "Offen:",
    noticesColumn: "Hinweise",
    callsTitle: "Anrufe",
    callsCount: "Anrufe: {n}",
    extensionPaid: "Verlängerung bezahlt",
    listCheckin: "Anreise",
    listCheckout: "Abreise",
    priceOriginal: "Ursprüngliche Buchung",
    priceExtension: "Verlängerung",
    priceTotal: "Gesamt",
    paymentInProcess: "Zahlung läuft",
    overbooking: "Overbooking",
    noAccommodationsFound: `Es wurden keine Unterkünfte gefunden, die zu "{term}" passen.`,
    past: "Vergangen",
    paymentInProcessLower: "Zahlung läuft",
    pendingApproval: "Genehmigung ausstehend",
    pendingApprovalTitle: "Genehmigung ausstehend",
    guestOne: "Gast",
    guestMany: "Gäste",
    perNight: "/ Nacht",
  },
  tableFilters: {
    filterByDate: "Nach Datum von - bis filtern",
    filterByCountry: "Nach Land filtern",
    all: "Alle",
    countrySpain: "Spanien",
    countryColombia: "Kolumbien",
    countryBrazil: "Brasilien",
    filterByState: "Nach Status filtern",
    allStates: "Alle Status",
    stateDemo: "Demoversion",
    stateSubscribed: "Abonniert",
    stateNotSubscribed: "Nicht abonniert",
    searchRecords: "Datensätze durchsuchen",
  },
  chatbotPageIndex: {
    aiAgentBadge: "KI-Agent",
    planFeatureHint: "Funktion verfügbar mit einem kostenpflichtigen Plan.",
    otaAgentTitle: "KI-Agent für OTAs",
    otaAgentHint: "Aktivieren Sie ihn, damit der Agent automatisch auf Nachrichten von Booking, Airbnb und anderen OTAs antwortet.",
    otaRequiresWhatsapp: "Erfordert einen aktiven WhatsApp-KI-Agenten.",
    guardNotice: "Bei deaktiviertem KI-Agenten wechselt der Chat automatisch auf <strong>manuelle Antwort</strong>. Die Schalter der einzelnen Unterhaltungen bleiben gesperrt, bis Sie ihn wieder aktivieren.",
    configureBasic: "Einfachen KI-Agenten einrichten",
    configureAdvanced: "Erweiterten KI-Agenten einrichten",
    comingSoon: "Demnächst",
    detailFallback: "Detail",
    errorLoadListingConfig: "Die Konfiguration des Inserats konnte nicht geladen werden",
    errorSaveChange: "Fehler beim Speichern der Änderung",
    otaAgentActivated: "KI-Agent für OTAs aktiviert",
    otaAgentDeactivated: "KI-Agent für OTAs deaktiviert",
  },
  chatbotIndex: {
    accommodationFallback: "Unterkunft",
    defaultHandoffSupportLine: "\nWenn Sie schnelle Hilfe brauchen, erreichen Sie uns unter {phone} 📞",
    defaultHandoffMessage: "Hallo 😊 Diese Information habe ich gerade nicht, aber jemand aus unserem Team meldet sich in Kürze bei Ihnen 🙌{suffix}\nWir sind während Ihres gesamten Aufenthalts für Sie da! 🏡✨",
    silentModeMessage: "An den Gast wird keine automatische Antwort gesendet. Das System benachrichtigt weiterhin den Mitarbeiter, damit er die Unterhaltung fortführen kann.",
    statusNoGuestReply: "Keine Antwort an den Gast",
    statusUsingCustom: "Eigene Nachricht wird verwendet",
    statusUsingDefault: "Standardnachricht wird verwendet",
    helperSilent: "Der Gast erhält keine automatische Antwort, wenn der KI-Agent nicht weiß, was er antworten soll, aber der Mitarbeiter erhält die Benachrichtigung, um die Unterhaltung zu übernehmen.",
    helperCustom: "Das System übersetzt diese eigene Nachricht automatisch in die Sprache des Gastes.",
    helperHasCustom: "Sie haben eine eigene Nachricht gespeichert, aber derzeit verwendet das System weiterhin die Standardnachricht.",
    helperDefault: "Wenn Sie eine Master-Nachricht erstellen, können Sie sie hier aktivieren, und das System übersetzt sie automatisch in die Sprache des Gastes.",
    sourceSilent: "Still",
    sourceCustom: "Eigene",
    sourceDefault: "Standard",
    defaultBotName: "Mein virtueller Assistent",
    errorLoadBotName: "Der Name des Assistenten konnte nicht geladen werden.",
    errorLoadHandoff: "Die Übergabenachricht konnte nicht geladen werden.",
    botNameUpdated: "Name des Assistenten aktualisiert.",
    errorSaveBotName: "Der Name des Assistenten konnte nicht gespeichert werden.",
    masterMessageUpdated: "Master-Nachricht aktualisiert.",
    errorSaveMaster: "Die Master-Nachricht konnte nicht gespeichert werden.",
    warnCreateCustomFirst: "Erstellen Sie zuerst eine eigene Nachricht, bevor Sie sie aktivieren.",
    modeCustomActivated: "Ab jetzt wird die eigene Nachricht verwendet.",
    modeSilentActivated: "Der Bot bleibt still, wenn er keine Antwort weiß, der Mitarbeiter wird aber weiterhin benachrichtigt.",
    modeDefaultActivated: "Ab jetzt wird die Standardnachricht verwendet.",
    errorUpdateActiveMessage: "Die aktive Nachricht konnte nicht aktualisiert werden.",
    warnWriteQuestion: "Schreiben Sie eine Frage, bevor Sie speichern.",
    questionCreated: "Frage erfolgreich erstellt.",
    errorAddQuestion: "Die Frage konnte nicht hinzugefügt werden.",
    botNamePlaceholder: "Name des Assistenten",
    handoffRowTitle: "Nachricht, wenn der Agent keine Antwort weiß",
    customize: "Anpassen",
    expandAria: "Aufklappen",
    handoffSubtitle: "Dieser Text wird gesendet, wenn der KI-Agent die Antwort weder in den Fakten noch im Gedächtnis oder in den FAQs findet.",
    modeDefaultTitle: "Standardnachricht",
    modeDefaultDesc: "Die Standardnachricht des Systems mit der Support-Telefonnummer verwenden.",
    modeCustomTitle: "Eigene Nachricht",
    modeCustomDescActive: "Den eigenen Text aktivieren, den Sie im Fenster gespeichert haben.",
    modeCustomDescEmpty: "Sie haben noch keine eigene Nachricht erstellt.",
    modeSilentTitle: "Nicht an den Gast antworten",
    modeSilentDesc: "Der Gast erhält keine automatische Nachricht, der Mitarbeiter wird aber benachrichtigt, um die Unterhaltung fortzuführen.",
    loadingMessage: "Nachricht wird geladen...",
    masterMessage: "Master-Nachricht",
    newQuestionTitle: "Neue Frage",
    newQuestionSubtitle: "Erstellen Sie eine neue häufige Frage, damit der KI-Agent sie genauer beantworten kann.",
    guestQuestionLabel: "Frage des Gastes",
    questionPlaceholder: "z. B. Wann ist der Check-in?",
    questionHelp: "Tipp: Formulieren Sie die Frage so, wie ein echter Gast sie stellen würde.",
    cancel: "Abbrechen",
    saveQuestion: "Frage speichern",
    handoffKicker: "Antwort bei Übergabe",
    handoffModalTitle: "Master-Nachricht anpassen",
    handoffModalSubtitle: "Schreiben Sie eine einzige Nachricht auf Spanisch. Das System übersetzt sie automatisch und antwortet in der Sprache, die der Gast spricht.",
    masterToolbarInfo: "Sie können Emojis und einen freundlichen Ton verwenden, genau wie in Ihren anderen automatischen Nachrichten.",
    emojiSearchPlaceholder: "Emoji suchen...",
    masterTextareaPlaceholder: "Schreiben Sie hier die Master-Nachricht. Sie können Emojis und einen herzlichen Ton für den Gast verwenden.",
    masterHint: "Empfehlung: Schreiben Sie die Nachricht auf Spanisch, in genau dem Ton, den Sie vermitteln möchten. Das System passt sie automatisch an die Sprache des Gastes an.",
    viewDefaultMessage: "Standardnachricht ansehen",
    saveMessage: "Nachricht speichern",
    newButton: "Neu",
    emojiButton: "Emoji",
  },
  messageAccountDemo: {
    usingDemo: "Sie nutzen die Demoversion",
    ofThePlatform: "der Plattform",
    trialHave: "Sie haben noch",
    trialDaysToEnjoy: "Tage, um alle Funktionen zu testen!",
    trialSubscribeNow: "Abonnieren Sie jetzt und verwalten Sie Ihre Unterkünfte ohne Unterbrechungen weiter.",
    subscribeNowLabel: "Jetzt abonnieren",
  },
};
